export const INACCESSIBLE_PARTIAL_TIP: 'partial_tip' = 'partial_tip'
export const INACCESSIBLE_WELL_SPACING_MISMATCH: 'labware_well_spacing' =
  'labware_well_spacing'
export const PLURAL_COLUMNS: 'columns' = 'columns'
export const PLURAL_ROWS: 'rows' = 'rows'
